function getMenuChildrenList(menuData) {
    let arr = []
    menuData.forEach(item => {
        let menuId = item.menuId + ''
        if (menuId.length == 6) {
            arr.push(item)
        }
    })

    arr.forEach((el, index) => {
        arr[index].children = []
    })

    menuData.forEach(item => {
        arr.forEach((el, index) => {
            if (el.menuId == item.parentId) {
                arr[index].children.push(item)
            }
        })
    })
    return arr
}
export default getMenuChildrenList